import { render, staticRenderFns } from "./UiDelete.vue?vue&type=template&id=40f27b4f&lang=pug&"
import script from "./UiDelete.vue?vue&type=script&lang=js&"
export * from "./UiDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports